import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { Button, Icons, InformationModal } from 'utoniq-ui'

import { useRouter, useTranslation } from '@/core'
import { Organism } from '@/core/architecture'
import { setRedirectAfterCreditCardRegisterPath } from '@/core/native/storage'

type PaymentErrorBaseModalProps = {
  open: boolean
  title: string
  content: string | ReactNode
  actionText: string
  cancelText: string
  onClose: () => void
}
const PaymentErrorBaseModal: Organism<PaymentErrorBaseModalProps> = ({
  open,
  title,
  content,
  actionText,
  cancelText,
  onClose,
}) => {
  const { router, routerPages } = useRouter()

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={
        <Stack alignItems="center" spacing={4}>
          <Icons.Error fontSize="large" sx={{ color: 'error.main' }} />
          <Typography variant="h5" sx={{ pb: 3 }}>
            {title}
          </Typography>
        </Stack>
      }
      content={content}
      buttons={
        <Button
          size="large"
          sx={{ width: 212 }}
          onClick={async () => {
            await setRedirectAfterCreditCardRegisterPath(router.pathname)
            router.push(`${routerPages.PaymentDetail}?reRegister=true`)
          }}
        >
          {actionText}
        </Button>
      }
      cancelText={cancelText}
    />
  )
}

type PaymentErrorModalProps = {
  open: boolean
  onClose: () => void
}
export const PaymentErrorModal: Organism<PaymentErrorModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('paymentError')
  return (
    <PaymentErrorBaseModal
      open={open}
      title={t('paymentErrorTitle')}
      content={t('paymentErrorDesc')}
      actionText={t('updatePaymentMethod')}
      cancelText={t('cancel')}
      onClose={onClose}
    />
  )
}

type ExpiredCardModalProps = {
  open: boolean
  onClose: () => void
}
export const ExpiredCardModal: Organism<ExpiredCardModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('paymentError')
  return (
    <PaymentErrorBaseModal
      open={open}
      title={t('expiredCardTitle')}
      content={t('expiredCardDesc')}
      actionText={t('updatePaymentMethod')}
      cancelText={t('cancel')}
      onClose={onClose}
    />
  )
}

type Require3DSecureModalProps = {
  open: boolean
  onClose: () => void
}
export const Require3DSecureModal: Organism<Require3DSecureModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('paymentError')
  return (
    <PaymentErrorBaseModal
      open={open}
      title={t('require3DSecureTitle')}
      content={t('require3DSecureDesc')}
      actionText={t('reRegisterCard')}
      cancelText={t('cancel')}
      onClose={onClose}
    />
  )
}
